import { render, staticRenderFns } from "./ProjectBasis.vue?vue&type=template&id=310c703b&"
import script from "./ProjectBasis.vue?vue&type=script&lang=js&"
export * from "./ProjectBasis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports